import React from "react";

export default function BillingToggle({ cycle, onChange, dark = false }) {
  const base = "px-4 py-1.5 text-[13px] font-medium rounded-sm transition-colors";
  const on = dark ? "bg-white text-brand" : "bg-brand text-white";
  const off = dark ? "text-white/70 hover:text-white" : "text-ink-muted hover:text-ink";
  return (
    <div className={`inline-flex items-center gap-1 p-1 border rounded-sm ${dark ? "border-white/20" : "border-ink-line bg-white"}`} data-testid="billing-toggle">
      <button type="button" onClick={() => onChange("monthly")} data-testid="billing-toggle-monthly" className={`${base} ${cycle === "monthly" ? on : off}`}>Monthly</button>
      <button type="button" onClick={() => onChange("annual")} data-testid="billing-toggle-annual" className={`${base} ${cycle === "annual" ? on : off}`}>
        Annual <span className={`ml-1 text-[11px] ${cycle === "annual" ? "" : "text-good"}`}>save 20%</span>
      </button>
    </div>
  );
}

export function PriceLine({ plan, cycle, pricing, featured = false }) {
  const p = pricing[plan];
  const amount = cycle === "monthly" ? p.monthly : p.annualPerMonth;
  return (
    <div className="mt-4" data-testid={`price-${plan}`}>
      <div className="flex items-baseline gap-1">
        <span className="font-num text-4xl font-bold tracking-tight">${amount}</span>
        <span className={`text-sm ${featured ? "text-white/70" : "text-ink-muted"}`}>/ month</span>
      </div>
      <div className={`text-[12px] mt-1 ${featured ? "text-white/70" : "text-ink-muted"}`}>
        {cycle === "annual" ? `Billed annually · $${p.annualTotal.toLocaleString()} / year` : "Billed monthly"}
      </div>
    </div>
  );
}
